import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuProviderService {
  private _isAdmin = false;
  private _enableNewAdvisor = false;
  private _enableOldAdvisor = false;
  private _enableReviewers = false;
  private _enableSampleStyles = false;
  private _sideMenuExpanded = new BehaviorSubject<boolean>(false);

  sidebarExpanded$ = this._sideMenuExpanded.asObservable();

  get isAdmin(): boolean {
    return this._isAdmin;
  }
  get enableNewAdvisor(): boolean {
    return environment.features.enableNewAdvisor;
  }
  get enableOldAdvisor(): boolean {
    return environment.features.enableOldAdvisor;
  }
  get enableReviewers(): boolean {
    return environment.features.enableReviewers;
  }

  get enableLibrary():  boolean {
    return environment.features.enableLibrary;
  }

  get enableSampleStyles(): boolean {
    return this._enableSampleStyles;
  }

 

  setFlags(isAdmin: boolean, enableNewAdvisor: boolean, enableReviewers: boolean) {
    this._isAdmin = isAdmin;
    this._enableNewAdvisor = enableNewAdvisor;
    this._enableReviewers = enableReviewers;
  }

  getMenuItems() {
    return [
      {
        icon: 'home',
        className: 'material-symbols-outlined',
        text: 'Home',
        route: '/home',
        show: true,
        description: ''
      },
      {
        icon: 'star',
        className: 'material-symbols-outlined',
        text: 'Advisor (Old)',
        route: '/advisor-old',
        show: this.enableOldAdvisor,
        description:
          'Ask complex questions to the LLM and receive detailed responses informed by context from your document collection. This process uses Retrival Augmented Generation (RAG) to provide comprehensive answers.'
      },
      {
        icon: 'rate_review',
        className: 'material-symbols-outlined',
        text: 'Advisor',
        route: '/advisor',
        show: this.enableNewAdvisor,
        description:
          'Ask complex questions to the LLM and receive detailed responses informed by context from your document collection. This process uses Retrival Augmented Generation (RAG) to provide comprehensive answers.'
      },
      {
        icon: 'group',
        className: 'material-symbols-outlined',
        text: 'Reviewers',
        route: '/reviewers',
        show: this.enableReviewers,
        description:
          'Evaluate a document through the lens of a configurable 3rd party in order to identify areas of improvement within your draft document.'
      },
      {
        icon: 'local_library',
        className: 'material-symbols-outlined',
        text: 'Library',
        route: '/library',
        show: this.enableLibrary, 
        description: 'Temp Libraries Description.'
      },
      {
        icon: 'home_storage',
        className: 'material-symbols-outlined',
        text: 'Collections',
        route: '/collections',
        show: true,
        description:
          'View an interactive table of your document collections and conduct advanced research across your document repository.'
      },
      {
        icon: 'joystick',
        className: 'material-symbols-outlined',
        text: 'Playground',
        route: '/playground',
        show: false, // feature/DRIFT-453-hide-playground-feature
        description:
          'Experiment with different prompt engineering techniques. You can load your previous prompts or create new ones. '
      },
      {
        icon: 'history',
        className: 'material-icons-outlined',
        text: 'Logs',
        route: '/prompt-log',
        show: true,
        description:
          'View recent logs of Advisor prompts. You can review previous prompt/response pairs, source information and create new drafts.'
      },
      {
        icon: 'assistant',
        className: 'material-icons-outlined',
        text: 'Admin',
        route: '/admin',
        show: this.isAdmin,
        description:
          'Edit and manage users and groups. Create and manage collections. Add and edit personas and system prompts'
      },
      {
        icon: 'rocket',
        className: 'material-icons-outlined',
        text: 'Sample Styles',
        route: '/sample-styles',
        show: this.enableSampleStyles,
        description: '(For Developers). A simple storybook-like page to view component styles for the application.'
      }
    ];
  }

  // Toggle the sidebar open/close, used to shape the chatbox in advisor
  toggleSidebar(isOpen: boolean) {
    this._sideMenuExpanded.next(isOpen);

    document.documentElement.style.setProperty('--sidebar-width', isOpen ? '240px' : '64px');
  }
}
